import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Page from "@/components/page/Page.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MatchingMunicipalities',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, null, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("section", null, [
        _createElementVNode("h3", null, "Uitleg"),
        _createElementVNode("p", null, "xxx")
      ], -1)
    ]))]),
    _: 1
  }))
}
}

})